import { Button } from '../components/Button';
import { Body, Screen, ScreenBody, Title } from '../components/Screen';
import { copy } from '../copy';

/**
 * The camera refusal, and only that.
 *
 * The ask itself moved onto the title page, where the storyboard puts it — see
 * TitleScreen and `usePermissionGate`. What is left is the one outcome that
 * genuinely stops the flow and needs a screen of its own: a guest who refused
 * the camera has to change a browser setting, which takes an explanation and a
 * real retry rather than an inline row.
 *
 * A refused microphone never lands here. That path continues silent.
 */
export function PermissionScreen() {
  return (
    <Screen>
      <div className="pt-12" />
      <ScreenBody>
        <Title>{copy.permission.denied.heading}</Title>
        <Body>{copy.permission.denied.body}</Body>
      </ScreenBody>
      <div className="w-full max-w-sm pb-4">
        <Button onClick={() => window.location.reload()}>{copy.permission.denied.cta}</Button>
      </div>
    </Screen>
  );
}
